const toggleDropdown = (target) => {
  const parent = target.closest('.dropdown-parent');
  if (!parent) {
    return;
  }

  parent.classList.toggle('is-active');
};

const handleEvent = (event) => {
  const target = event.target.closest('[data-toggle-dropdown]');
  if (target) {
    event.preventDefault();
    toggleDropdown(target);
  }
};

const setupEvents = () => {
  document.documentElement.addEventListener('click', handleEvent);
};

setupEvents();
